module.exports = __webpack_public_path__ + "img/s03_poster.e91e4d67.jpg";